/**
 * 夥伴管理各頁共用的標籤與格式化。
 *
 * 放在 lib 而非某個 page：清單、詳情與三個分頁元件都要用，讓元件去 import 頁面
 * 會造成反向相依（頁面 → 元件 → 頁面）。
 */

import type { PartnerTier } from './api-client';
import type { PillTone } from '../components/Pill';

export const TIER_LABEL: Record<PartnerTier, string> = {
  T1: 'T1 基本',
  T2: 'T2 進階',
  T3: 'T3 旗艦',
};

export const TIER_TONE: Record<PartnerTier, PillTone> = {
  T1: 'neutral',
  T2: 'brand',
  T3: 'success',
};

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('zh-TW', { hour12: false });
}

/**
 * 配額數字加千分位。
 *
 * 收 `number | string` 是因為 `quota_per_month` 在 DB 是 bigint，node-pg 以字串
 * 回傳；直接對字串呼叫 `.toLocaleString()` 會原樣回傳，千分位靜默消失。
 */
export function formatQuota(v: number | string): string {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n.toLocaleString('zh-TW') : String(v);
}
